import { BodyPower } from "./BodyPower";
export default BodyPower;
